import { render } from "./QueOptionArea.vue?vue&type=template&id=3ecb8c00"
import script from "./QueOptionArea.vue?vue&type=script&lang=js"
export * from "./QueOptionArea.vue?vue&type=script&lang=js"

import "./QueOptionArea.vue?vue&type=style&index=0&id=3ecb8c00&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__